// Get All
export const GET_HOMEPAGE = "GET_HOMEPAGE";
export const GET_HOMEPAGE_SUCCESS = "GET_HOMEPAGE_SUCCESS";
export const GET_HOMEPAGE_FAIL = "GET_HOMEPAGE_FAIL";

// Get Most Viewd
export const GET_MOSTLY_VIEW = "GET_MOSTLY_VIEW";
export const GET_MOSTLY_VIEW_SUCCESS = "GET_MOSTLY_VIEW_SUCCESS";
export const GET_MOSTLY_VIEW_FAIL = "GET_MOSTLY_VIEW_FAIL";

// Get Latest NFT
export const GET_LATEST = "GET_LATEST";
export const GET_LATEST_SUCCESS = "GET_LATEST_SUCCESS";
export const GET_LATEST_FAIL = "GET_LATEST_FAIL";

// Get Top Collections
export const GET_TOP_COLLECTIONS = "GET_TOP_COLLECTIONS";
export const GET_TOP_COLLECTIONS_SUCCESS = "GET_TOP_COLLECTIONS_SUCCESS";
export const GET_TOP_COLLECTIONS_FAIL = "GET_TOP_COLLECTIONS_FAIL";

// Get Explore
export const GET_EXPLORE = "GET_EXPLORE";
export const GET_EXPLORE_SUCCESS = "GET_EXPLORE_SUCCESS";
export const GET_EXPLORE_FAIL = "GET_EXPLORE_FAIL";

// Get Secondry NFT's
export const GET_SECONDRY_SALE = "GET_SECONDRY_SALE";
export const GET_SECONDRY_SALE_SUCCESS = "GET_SECONDRY_SALE_SUCCESS";
export const GET_SECONDRY_SALE_FAIL = "GET_SECONDRY_SALE_FAIL";

// POST Follow
export const POST_FOLLOW = "POST_FOLLOW,";
export const POST_FOLLOW_SUCCESS = "POST_FOLLOW_SUCCESS,";
export const POST_FOLLOW_FAIL = "POST_FOLLOW_FAIL,";
export const GET_FOLLOW = "GET_FOLLOW,";
export const GET_FOLLOW_SUCCESS = "GET_FOLLOW_SUCCESS,";
export const GET_FOLLOW_FAIL = "GET_FOLLOW_FAIL,";

export const GET_BLOGS = "GET_BLOGS";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_BLOGS_FAIL = "GET_BLOGS_FAIL";

export const GET_BLOGS_BY_ID = "GET_BLOGS_BY_ID";
export const GET_BLOGS_BY_ID_SUCCESS = "GET_BLOGS_BY_ID_SUCCESS";
export const GET_BLOGS_BY_ID_FAIL = "GET_BLOGS_BY_ID_FAIL";
